module.exports = __webpack_public_path__ + "static/media/arrow.d32ceb55.png";